<template>
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <!-- {{accountsOptions}}
          <hr />-->
          <!-- {{formParam}}
          <hr />
          
          {{formParamScrapeSt}}-->
          <div class="row">
            <div class="col-md-6">
              <div class="col-md-12 profile-info-left">
                <div class="col-md-12">
                  <div class="form-group row">
                    <label class="col-form-label">
                      Title
                      <span class="text text-danger">*</span>
                    </label>
                    <input type="text" v-model="formParam.title" class="form-control" />
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group row">
                    <label class="col-form-label">
                      Brand/Merek
                      <span class="text text-danger">*</span>
                    </label>
                    <multiselect
                      v-model="selectedContact"
                      id="ajax"
                      label="name"
                      track-by="id"
                      :placeholder="'Type to search Brand...'"
                      :multiple="true"
                      open-direction="bottom"
                      :custom-label="customLabel"
                      :options="contactOptions"
                      :searchable="true"
                      :loading="isLoading"
                      :internal-search="false"
                      :close-on-select="false"
                      :options-limit="300"
                      :limit="3"
                      :limit-text="limitText"
                      :max-height="600"
                      :show-no-results="true"
                      :hide-selected="true"
                      @search-change="asyncFind"
                      :show-labels="false"
                      @remove="removeContact"
                    >
                      <template slot="tag" slot-scope="{ option, remove }">
                        <span class="custom__tag">
                          <span>{{option.name}}</span>
                          <span class="custom__remove" @click="remove(option)">❌</span>
                        </span>
                      </template>
                      <template slot="clear" slot-scope="props">
                        <div
                          class="multiselect__clear"
                          v-if="selectedContact.length"
                          @mousedown.prevent.stop="clearAll(props.search)"
                        ></div>
                      </template>
                      <span slot="noResult">Oops! No elements found.</span>
                    </multiselect>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="col-md-12">
                <div class="form-group row">
                  <label class="col-form-label">
                    Media Type
                    <span class="text text-danger">*</span>
                  </label>
                  <select v-model="formParam.media_type" class="form-control">
                    <option value>Options</option>
                    <option
                      v-for="(row,idx) in dataMediaTypeList"
                      :value="row.id"
                      :key="idx"
                    >{{row.label}}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group row">
                  <label class="col-form-label">
                    Accounts
                    <span class="text text-danger">*</span>
                  </label>
                  <multiselect
                    v-model="selectedAccounts"
                    id="ajax"
                    label="name"
                    track-by="id"
                    :placeholder="''"
                    :multiple="true"
                    :custom-label="customLabelAccount"
                    :options="accountsOptions"
                    :searchable="true"
                    :loading="isLoading"
                    :internal-search="false"
                    :close-on-select="false"
                    :options-limit="300"
                    :limit="3"
                    :limit-text="limitText"
                    :max-height="600"
                    :show-no-results="true"
                    @search-change="asyncFindAccounts"
                    @select="dispatchSelectOption"
                    @remove="removeAccounts"
                  >
                    <template slot="tag" slot-scope="{ option, remove }">
                      <span class="custom__tag">
                        <span>{{ option.username }}</span>
                        <span class="custom__remove" @click="remove(option)">❌</span>
                      </span>
                    </template>
                    <template slot="clear" slot-scope="props">
                      <div
                        class="multiselect__clear"
                        v-if="selectedAccounts.length"
                        @mousedown.prevent.stop="clearAll(props.search)"
                      ></div>
                    </template>
                    <span slot="noResult">Oops! No elements found.</span>
                  </multiselect>
                  <div v-if="selectedAccounts.length">
                    <span
                      class="badge badge-info"
                      v-for="(row,idx) in selectedAccounts"
                      :key="idx"
                    >{{row.username}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

export default {
  components: {
    Skeleton,
    Multiselect
  },
  props: {
    activeIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      showProduct: false,
      limitSelectedAccounts: 2,
      selectedAccounts: [],
      accountsOptions: [],
      accountsListParam: {
        brand_id: "",
        username: "",
        page: 0,
        perPage: 20
      },
      dataMediaTypeList: [],
      selectedProduct: [],
      productOptions: [],
      productListParam: {
        brand_id: "",
        name: "",
        page: 0,
        perPage: 20
      },
      selectedContact: [],
      contactOptions: [],
      contactListParam: {
        name: "",
        page: 0,
        perPage: 20
      },
      isSending: false,
      dataListMonitoringStatus: [],
      dataListMarketplace: [],
      formParam: {
        title: "",
        brand_id: "",
        instagram_account_id: [],
        media_type: "photo"
      },
      isLoading: false
    };
  },
  watch: {
    formParamScrapeSt: {
      handler: async function(val, oldVal) {
        if (val != oldVal && val.id != "") {
          let currentParam = {};
          currentParam.title = val.title;
          let copy = this.$route.query.copy;
          if (typeof copy != "undefined" && copy == "1") {
            currentParam.title = currentParam.title + " - COPY";
          }
          currentParam.brand_id = val.brand_id;
          currentParam.media_type = val.media_type;
          currentParam.instagram_account_id = val.instagram_account_id;

          this.formParam = currentParam;

          this.selectedContact = [];
          this.contactOptions = [];
          this.$store
            .dispatch("brand/detail", this.formParamScrapeSt.brand_id) // sesuai kan dengan method di API
            .then(responseDet => {
              var resData = responseDet.data;
              this.contactOptions.push(resData);
              this.selectedContact.push(resData);
            });
          var that = this;
          setTimeout(function() {
            that.accountsOptions = [];
            that.selectedAccounts = [];
            that.formParam.instagram_account_id.forEach(async (accId, idx) => {
              that.$store
                .dispatch("instagramAccount/detail", accId) // sesuai kan dengan method di API
                .then(async responseDet => {
                  var resData = responseDet.data;
                  that.accountsOptions.push(resData);
                  that.selectedAccounts.push(resData);
                });
            });
          }, 200);
        }
      },
      deep: true
    },
    formParam: {
      handler: function(val, oldVal) {
        // if (val != oldVal) {
        // console.log("oldVal", oldVal);
        // console.log("newVal", val);
        this.formValidate();
        // }
      },
      deep: true
    },
    selectedContact: {
      handler: function(val, oldVal) {
        // console.log("val.id", val.id, val.length);
        if (val.length > 1) {
          let lengthOld = oldVal.length;
          val.splice(0, 1);
          this.selectedContact = val;
          // this.asyncFindProduct()
        }
        if (val.length == 1) {
          this.accountOptions = [];
          // this.selectedAccounts = [];
          this.formParam.brand_id = val[0].id;
          this.asyncFindAccounts();
          // this.searchData();
        } else {
          this.accountOptions = [];
          // this.selectedAccounts = [];
          this.formParam.brand_id = "";
          // this.searchData();
        }
      },
      deep: true
    },
    activeIndex: {
      handler: function(val, oldVal) {
        // console.log("val", val, "oldVal", oldVal);
        if (val == true) {
          // this.selectedLicense = [];
          var that = this;
          setTimeout(function() {
            // console.log("that.broadcastParamSt", that.broadcastParamSt);
            // that.formParam = that.formParamSt;
            // if (val == 0) {
            //   that.asyncFind();
            //   that.getMonitoringSortByList()
            // }
            // that.asyncFindProduct();
            // console.log("")
          }, 100);
        }
      },
      deep: true
    }
  },
  computed: {
    formParamScrapeSt() {
      return this.$store.state.instagramSchedule.formParamScrapeSt;
    }
    // isShowForm() {
    //   return this.$store.state.monitoring.isShowForm;
    // }
  },
  filters: {
    capitalising: function(data) {
      var capitalized = [];
      data.split(" ").forEach(word => {
        capitalized.push(
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );
      });
      return capitalized.join(" ");
    }
  },
  methods: {
    formValidate() {
      let newParam = this.formParamScrapeSt;
      //   newParam = currentParam;
      newParam.title = this.formParam.title;
      newParam.instagram_account_id = this.formParam.instagram_account_id;
      newParam.media_type = this.formParam.media_type;
      newParam.brand_id = this.formParam.brand_id;

      this.$store.dispatch("instagramSchedule/actFormParamScrapeSt", newParam);
      //   console.log("newParam", newParam);
    },
    async removeContact(tag) {
      this.selectedContact = [];
      // this.selectedAccounts = [];
      this.accountsOptions = [];
    },
    async removeAccounts(tag) {
      if (this.formParam.instagram_account_id.length) {
        var index = this.formParam.instagram_account_id.indexOf(tag.id);
        if (index !== -1) {
          this.formParam.instagram_account_id.splice(index, 1);
        }
        if (this.selectedAccounts != null) {
          var that = this;
          setTimeout(function() {
            var index2 = that.selectedAccounts
              .map(x => {
                return x.id;
              })
              .indexOf(tag.id);
            // console.log("index2", index2);

            if (index2 >= 0) {
              that.selectedAccounts.splice(index2, 1);
            }
          }, 300);
        }
      }
      //   console.log("removekyeowrd", tag);
      //   console.log("selectedAccounts", this.selectedAccounts);
    },
    dispatchSelectOption(optionSelected) {
      let idTag = optionSelected.id;
      this.formParam.instagram_account_id.push(idTag.toString());
    },
    asyncFindAccounts(query) {
      if (this.selectedContact.length < 1) {
        return;
      }
      this.isLoading = true;
      this.accountsListParam.name = query;
      this.accountsListParam.brand_id = this.selectedContact[0].id;
      this.$store
        .dispatch("instagramAccount/list", this.accountsListParam)
        .then(response => {
          this.isLoading = false;
          this.accountsOptions = response.data.data;
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    getMediaTypeList() {
      this.isLoading = true;
      this.$store
        .dispatch("instagramSchedule/getMediaTypeList")
        .then(response => {
          this.isLoading = false;
          this.dataMediaTypeList = response.data;
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    asyncFindProduct(query) {
      if (this.selectedContact.length < 1) {
        return;
      }
      this.isLoading = true;
      this.productListParam.name = query;
      // console.log("selectedContact", this.selectedContact);
      this.productListParam.brand_id = this.selectedContact[0].id;
      this.$store
        .dispatch("brandProduct/list", this.productListParam)
        .then(response => {
          this.isLoading = false;
          this.productOptions = response.data.data;
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    limitText(count) {
      return `and ${count} other`;
    },
    customLabel({ name }) {
      return `${name}`;
    },
    customLabelAccount({ username }) {
      return `${username}`;
    },
    asyncFind(query) {
      this.isLoading = true;
      this.contactListParam.name = query;
      this.$store
        .dispatch("brand/list", this.contactListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data.data;
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    clearAll() {
      this.selectedContact = [];
    }
  },
  async created() {
    this.asyncFind();
    this.getMediaTypeList();
    this.$root.$on(
      "on-validate",
      validationResult => {
        console.log("validationResult", validationResult);
      },
      activeTabIndex => {
        console.log("activeTabIndex", activeTabIndex);
      }
    );
  },
  beforeDestroy() {},
  mounted() {
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "buttons-add"
};
</script>


// WEBPACK FOOTER //
// src/views/instagram/instagramSchedule/components/form1.vue